import React, { useEffect, useRef, useState } from "react";
import { chatHistory, chatTurn } from "../../../api/minisite";

export default function ChatTab({ clientId, onAgentAction }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const scrollRef = useRef();

  // Charge l'historique au mount (sinon les messages déjà saisis ne s'affichent pas)
  useEffect(() => {
    (async () => {
      try {
        const m = await chatHistory(clientId);
        if (m && m.length) setMessages(m);
      } catch (e) {
        // 404 ou autre — pas grave, on démarre avec un chat vide
      }
    })();
  }, [clientId]);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [messages]);

  const send = async () => {
    if (!input.trim() || busy) return;
    setBusy(true);
    setError(null);
    try {
      const r = await chatTurn(clientId, input.trim());
      setMessages(r.messages || []);
      setInput("");
      if (r.draft_changed) onAgentAction && onAgentAction();
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: 500 }}>
      <div ref={scrollRef} style={{ flex: 1, overflowY: "auto", padding: 12,
                                     border: "1px solid #eee", borderRadius: 8 }}>
        {messages.length === 0 && (
          <div style={{ color: "#999" }}>
            Pose une question à l'agent ou demande-lui une action (ex: "pré-remplis depuis l'autobio", "réécris le chapitre 3 plus court", "publie le minisite").
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{
            margin: "8px 0",
            padding: 8,
            background: m.role === "user" ? "#e0f2fe" : "#f3f4f6",
            borderRadius: 6,
          }}>
            <strong>{m.role === "user" ? "Toi" : "Assistant"}</strong>
            <div style={{ whiteSpace: "pre-wrap", marginTop: 4 }}>
              {typeof m.content === "string" ? m.content : JSON.stringify(m.content)}
            </div>
          </div>
        ))}
      </div>
      {error && <div style={{ color: "red", padding: 8 }}>{error}</div>}
      <div style={{ display: "flex", marginTop: 12, gap: 8 }}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()}
          disabled={busy}
          placeholder="Tape une question ou une instruction..."
          style={{ flex: 1, padding: 10 }}
        />
        <button onClick={send} disabled={busy || !input.trim()}>
          {busy ? "..." : "Envoyer"}
        </button>
      </div>
    </div>
  );
}
